export const manifest = {
  screens: {
    scr_swjl4s: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_5fjsvu: { name: "Agent Login", route: "/agents", position: {"x":1560,"y":220} },
    scr_5asyho: { name: "Training Portal", route: "/agents", state: {"authenticated":true}, position: {"x":160,"y":2200} },
  },
  sections: {
    sec_hzvl0t: { name: "Entry & Authentication", x: 0, y: 0, width: 2920, height: 1180 },
    sec_b2cxe8: { name: "Agent Portal", x: 0, y: 1980, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_hzvl0t", children: [
      { kind: "screen", id: "scr_swjl4s" },
      { kind: "screen", id: "scr_5fjsvu" },
    ] },
    { kind: "section", id: "sec_b2cxe8", children: [
      { kind: "screen", id: "scr_5asyho" },
    ] },
  ],
}
